import { render, staticRenderFns } from "./Configs.vue?vue&type=template&id=af06e15a&scoped=true&"
import script from "./Configs.vue?vue&type=script&lang=js&"
export * from "./Configs.vue?vue&type=script&lang=js&"
import style0 from "./Configs.vue?vue&type=style&index=0&id=af06e15a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af06e15a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/piscinaFacilDev/piscinapp-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af06e15a')) {
      api.createRecord('af06e15a', component.options)
    } else {
      api.reload('af06e15a', component.options)
    }
    module.hot.accept("./Configs.vue?vue&type=template&id=af06e15a&scoped=true&", function () {
      api.rerender('af06e15a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/configs/Configs.vue"
export default component.exports